/* unplugin-vue-components disabled */import script from "./Hpkf.vue?vue&type=script&lang=ts&setup=true"
export * from "./Hpkf.vue?vue&type=script&lang=ts&setup=true"

import "./Hpkf.vue?vue&type=style&index=0&id=3acc29be&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acc29be"]])

export default __exports__